import sha256 from 'crypto-js/sha256';
import sessionActions from '../actions/SessionActions';
import storeManager from '../store/StoreManager';
import stateCacheService from './StateCache';
import timeService from './TimeService';
import sessionReader from '../store/readHelpers/SessionReader';
import navigationService from './NavigationService';
import candidateBlockageReason from '../constants/CandidateBlockageReason';

const loginService = {
    checkCredentials(password, userId) {
        if (!window.candidatesInfo) {
            return false;
        }

        const passwordHash = sha256(password).toString();
        const candidateId = Object
            .keys(window.candidatesInfo)
            .find((key) => {
                const candidate = window.candidatesInfo[key];
                return candidate.password === passwordHash && `${candidate.userId}` === userId;
            });

        if (candidateId) {
            return Object.assign({ candidateId }, window.candidatesInfo[candidateId]);
        }

        return false;
    },

    tryLogin(password, username) {
        const candidateInfo = this.checkCredentials(password, username);
        if (candidateInfo) {
            const { candidateId, duration, userId, fileSaveId, fileSaveKey } = candidateInfo;
            storeManager.dispatch(
                sessionActions.setIsLoggedIn(true)
            );

            const sessionInfo = storeManager.getState().session.sessionInfo || {};
            storeManager.dispatch(
                sessionActions.setSessionInfo(
                    Object.assign({}, sessionInfo, { candidateId, userId, fileSaveId, fileSaveKey })
                )
            );

            const timeRemaining = stateCacheService.getStateCacheInstance().getTimeRemaining() || duration;
            timeService.dispatchTimeRemaining(timeRemaining, true, duration);
            timeService.start(sessionReader.getAssessmentRunId(true));

            return true;
        }

        return false;
    },

    logout() {
        storeManager.dispatch(
            sessionActions.setIsLoggedIn(false)
        );

        const sessionInfo = storeManager.getState().sessionInfo || {};
        storeManager.dispatch(
            sessionActions.setSessionInfo(
                Object.assign({}, sessionInfo, { candidateId: undefined, userId: undefined, fileSaveId: undefined, fileSaveKey: undefined })
            )
        );
    },

    handleStudentEviction(blockageReason) {
        if (blockageReason === candidateBlockageReason.EVICTION) {
            const candidateId = sessionReader.getCandidateId();
            console.log(`Candidate ${candidateId} is blocked. Blockage reason is "${blockageReason}"`);

            navigationService.exitTest();
        }
    },
};

export default loginService;
